import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';
import { ApiResponse } from 'src/app/models/IApiResponse';

@Injectable({
  providedIn: 'root'
})
export class AllNotificationsService {
  private baseURL = environment.apiURL;

  private headers = new HttpHeaders({ 'Content-Type': 'application/json','Accept': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

   /**
   * Get all notifications
   * @param id
   */
    getAll():Observable<ApiResponse>{

      let apiURL:string=`${this.baseURL}/v1/notifications/all`;

      return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));

    }
}
